import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import defaultAttributeFilters from "./defaultAttributeFilters.json";
import { Catalogue, CatalogueProps } from "./Catalogue";

const preloadedProps: CatalogueProps = (window as any).__PRELOADED_PROPS__;

// Convert filters from compressed ones into full, that catalogue supports
const uncompressedFilters = preloadedProps.availableAttributeFilters.map(filter => {
  return {
    ...filter,
    options: filter.options.map(opt => {
      return typeof opt === "string" ? { value: opt, label: opt } : opt;
    })
  };
});

ReactDOM.hydrate(
  <Catalogue
    {...preloadedProps}
    availableAttributeFilters={uncompressedFilters.length > 0 ? uncompressedFilters : defaultAttributeFilters}
  />,
  document.getElementById("root")
);
